const StatusEffects = () => {
    return (
        <>
            <h3 className="text-center">StatusEffects</h3>
        </>
    )
}

export default StatusEffects;